import { createRequestTypes } from '../utils';

export const START_HANGFIRE = createRequestTypes('controlCenter/START_HANGFIRE');
export const STOP_HANGFIRE = createRequestTypes('controlCenter/STOP_HANGFIRE');
export const ALLOW_LOGIN = createRequestTypes('controlCenter/ALLOW_LOGIN');
export const PROHIBIT_LOGIN = createRequestTypes('controlCenter/PROHIBIT_LOGIN');
